import { useContext } from 'react'

import { MenuCollapsedState } from '../context'

export function useMenuCollapsedState() {
  return useContext(MenuCollapsedState)
}
